class VueInflected {
  constructor (Vue, ...inflections) {
    const Inflected = require('inflected')
    const instance = this

    Vue.inflected = instance

    Object.defineProperties(Vue.prototype, {
      $inflected: {
        get () {
          return instance
        }
      }
    })

    Inflected.inflections(...inflections)

    Object.defineProperties(this, {
      pluralize: {
        value: Inflected.pluralize
      },
      singularize: {
        value: Inflected.singularize
      },
      camelize: {
        value: Inflected.camelize
      },
      underscore: {
        value: Inflected.underscore
      },
      humanize: {
        value: Inflected.humanize
      },
      titleize: {
        value: Inflected.titleize
      },
      tableize: {
        value: Inflected.tableize
      },
      classify: {
        value: Inflected.classify
      },
      dasherize: {
        value: Inflected.dasherize
      },
      foreignKey: {
        value: Inflected.foreignKey
      },
      ordinal: {
        value: Inflected.ordinal
      },
      ordinalize: {
        value: Inflected.ordinalize
      },
      inflections: {
        value: Inflected.inflections
      },
      transliterate: {
        value: Inflected.transliterate
      },
      parameterize: {
        value: Inflected.parameterize
      },
      constantify: {
        value: Inflected.constantify
      }
    })

    Object.freeze(instance)
  }
}

/**
* Vue Inflected plugin
*
* @param {Object} Vue
*/
function plugin (Vue, ...inflections) {
  if (plugin.installed) {
    return
  } else {
    plugin.installed = true
  }

  return (Vue.$inflector || new VueInflected(Vue, ...inflections))
}

export default plugin
